import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss']
})
export class ImageModalComponent implements OnInit {
	imageUrl:string = "";
	imageType:string = "";

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<ImageModalComponent>,
	) {
		if (data) {
      console.log('data->', data);
      this.imageUrl = data.url;
      this.imageType = data.imageType
		}
	}

	ngOnInit() {}
}

